import React from "react";

import styles from "./Error.scss";
import strings from "./strings";

const Error = () => <div className={styles.error}>{strings.ERROR_MESSAGE}</div>;

export default Error;
